
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 根据登录管理员获取相关部门列表
export function getSysDeptList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/sysDept/tree/auth',
    method: 'GET',
    params: parameter
  })
}
// 分页，获取所有考核列表
export function getUserEvaluateList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/evaluate/list',
    method: 'GET',
    params: parameter
  })
}
// 分页 获取某个人的考核记录信息
export function getUserEvaluateOne (parameter) {
  return axios({
      url: sysInfo.apiRemote + '/user/evaluate/one',
      method: 'GET',
      params: parameter
    })
  }
// 提交填写完成的考核结果
export function putUserEvaluateOne (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/user/evaluate/one',
    method: 'PUT',
    data: parameter
  })
}
// 忽略考核结果
export function DeleteUserEvaluateOne (parameter) {
  return axios({
    url: sysInfo.apiRemote +'/user/evaluate/one',
    method: 'DELETE',
    data: parameter
  })
}
